/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachPinIcon24Solid = forwardRef('AttachPinIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M15.66 1.769c-.704-.704-1.906-.206-1.906.79 0 1.38-.549 2.703-1.525 3.68l-.115.116a5.601 5.601 0 0 1-3.961 1.64H4.774c-1.336 0-2.005 1.616-1.06 2.561l3.804 3.805-4.579 4.578a1.5 1.5 0 0 0 2.122 2.122l4.578-4.58 3.803 3.803c.944.945 2.56.276 2.56-1.06v-3.38c0-1.485.59-2.91 1.64-3.96l.117-.116a5.205 5.205 0 0 1 3.68-1.525c.995 0 1.493-1.202.79-1.906l-6.57-6.568Z" })));
});
